/**
 * Where "write to me" goes.
 *
 * Diana keeps two chats in settings: a Telegram link she pastes, and a
 * WhatsApp number she types the way she says it out loud. Both have to end
 * up as one tap that opens HER chat — on a phone and in a desktop browser —
 * so a bare number becomes the canonical wa.me form here rather than in
 * three call sites.
 */

/** A pasted link is trusted as-is; anything else is read as a phone number. */
export function whatsappHref(value: string, message?: string): string | null {
  const raw = value.trim()
  if (!raw) return null

  const text = message ? `text=${encodeURIComponent(message)}` : ''

  if (/^https?:\/\//i.test(raw)) {
    if (!text) return raw
    return raw.includes('?') ? `${raw}&${text}` : `${raw}?${text}`
  }

  // wa.me wants digits only — no +, no spaces, no dashes.
  const digits = raw.replace(/\D/g, '')
  if (!digits) return null
  return text ? `https://wa.me/${digits}?${text}` : `https://wa.me/${digits}`
}
